export enum Sorting {
  DepartureTime = 'departure_time',
  ArrivalTime = 'arrival_time',
  Price = 'price',
  Transfers = 'transfers',
  Duration = 'duration',
}

export enum Filter {
  DirectOnly = 'direct_only',
  DepartureTime = 'departure_time',
  FareClass = 'fare_classes',
  Services = 'services',
  DepartureStation = 'departure_stations',
  ArrivalStation = 'arrival_stations',
  TrainType = 'train_type',
  Price = 'price',
  Carriers = 'marketing_carriers',
}

export enum IdFields {
  Type = 'document_type',
  Citizenship = 'citizenship',
  Location = 'location_of_issue',
  ExpirationDate = 'expiration_date',
}

export enum PaymentMethodStatus {
  Pending,
  Ready,
  Rejected,
}

export const enum ReservationErrors {
  InProgress = 'reservationInProgress',
  Confirmed = 'reservationAlreadyConfirmed',
}

export const enum ReservationStatusErrors {
  Shopper = 'shopper',
}

export const enum RetryOptions {
  ConfirmationOnly = 'confirmation_only',
  NewReservation = 'new_reservation',
}

export enum TicketValidity {
  FullDayHours = 24,
  FullDayMinutes = 24 * 60,
  FullDayDays = 1,
}

export enum PaymentCardLabels {
  mc = 'Mastercard',
  visa = 'Visa',
  amex = 'American Express',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  americanExpress = 'American Express',
  me = 'Maestro',
  cartebancaire = 'Cartes Bancaires',
}

export enum CheckoutSteps {
  None,
  Details,
  Payment,
  Confirmation,
}

export const enum CheckoutFormFields {
  SplitFareClasses = 'split_fare_classes',
  PassengerDetails = 'passenger_details',
  Contact = 'contact',
  FareClassSelection = 'fare_class_selection',
  Discounts = 'discounts',
  Seats = 'seats',
  Extras = 'extras',
}
